import { SESSION, API } from '@/constants/constants'

/**
 * Feature switches for this install, as the API sent them at login
 * (config/features.php on the Laravel side). Hiding here is cosmetic — the
 * API refuses the routes behind a switched-off feature — but a menu entry
 * that 404s is worse than no entry.
 */
export function setFeatures(map) {
  try { localStorage.setItem(SESSION.FEATURES, JSON.stringify(map || {})) } catch (e) { /* storage may be unavailable */ }
}

function read() {
  try {
    const raw = localStorage.getItem(SESSION.FEATURES)
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    return {}
  }
}

/**
 * Fetch the map from the API when the session predates it (a user who logged
 * in before features existed would otherwise see every optional module
 * vanish until they logged in again). Once per page load.
 */
let _refreshed = false
export async function refreshFeaturesOnce() {
  if (_refreshed) return
  _refreshed = true
  if (localStorage.getItem(SESSION.FEATURES)) return
  try {
    // Imported here, not at the top: utils → router → this file would be a cycle at load.
    const { apiHelper } = await import('@/utils')
    const res = await apiHelper(API.BASE_URL + '/v1').get('/features')
    setFeatures((res && res.data) || {})
  } catch (e) {
    // Keep going without a map: feature() then reads false, which hides, never breaks.
  }
}

/** True when the named feature is on. No name = no restriction. */
export function feature(name) {
  if (!name) return true
  return read()[name] === true
}
